import { render, staticRenderFns } from "./org_type_list.vue?vue&type=template&id=16362c9a&scoped=true"
import script from "./org_type_list.vue?vue&type=script&lang=js"
export * from "./org_type_list.vue?vue&type=script&lang=js"
import style0 from "./org_type_list.vue?vue&type=style&index=0&id=16362c9a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16362c9a",
  null
  
)

export default component.exports